/**
 * @typeof {import('@goodt-common/infra/BaseDto').BaseDto} BaseDto
 */
import { success } from '@goodt-common/utils';
import { applyConstructorOrFactory, BaseDto, buildDtoSafeResult } from '@goodt-common/infra';

/**
 * @param {SafeResult} safeResult
 * @param {import('./utils').DtoConstructorOrFactory} [DtoConstructorOrFactory=BaseDto]
 * @param {import('./utils').ProcessRequestResultOptions} [options]
 * @return {SafeResult}
 */
export const processRequestResult = (
    safeResult,
    DtoConstructorOrFactory = BaseDto,
    { resultTransformer = (x) => x } = {}
) => {
    const { isError, result } = safeResult;

    if (isError) {
        return safeResult;
    }
    const finalResult = resultTransformer(result);

    // Не обрабатывать результат
    if (finalResult instanceof DtoConstructorOrFactory) {
        return success(finalResult);
    }
    if (typeof DtoConstructorOrFactory !== 'function') {
        return success(finalResult);
    }
    if (typeof finalResult !== 'object' && DtoConstructorOrFactory === BaseDto) {
        return success(finalResult);
    }

    // Обрабатывать как BaseDto
    // prettier-ignore
    if (typeof finalResult === 'object'
        && DtoConstructorOrFactory === BaseDto
        || BaseDto.isPrototypeOf(DtoConstructorOrFactory)
    ) {
        return buildDtoSafeResult(DtoConstructorOrFactory, finalResult);
    }

    // Обрабатывать указанным конструктором или фабрикой
    return success(applyConstructorOrFactory(DtoConstructorOrFactory, finalResult));
};

/**
 *
 * @param {LearningCourseApiService} service
 * @param {Record<string, Function>} extensionsDescriptor
 * @return {*}
 */
export function useExtensions(service, extensionsDescriptor) {
    // eslint-disable-next-line
    return Object.assign(service, extensionsDescriptor);
}
